module.exports = __webpack_public_path__ + "img/folder-black.8d2e7634.svg";